import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const cirrhosis: AnswerPathTreeNode = {
  path: 'cirrhosis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCirrhosisDetails }],
};
